/**
 * Only to be used in WPO optimalisation
 */

import './components/animation';
import { hoverIntent } from './components/menu';

document.addEventListener('DOMContentLoaded', () => {
	const menuItems = document.querySelectorAll('#menu li.menu-item-has-children > a');

	if ('ontouchstart' in document.documentElement) {
		document.body.classList.add('has-touch');
		if (menuItems.length) {
			menuItems.forEach((item) => {
				item.addEventListener('touchstart', (e) => {
					menuItems.forEach((item) => item.classList.remove('menu-item-visible'));
					e.preventDefault();
					item.classList.add('menu-item-visible');
				});
			});
		}
	} else {
		if (menuItems.length) {
			hoverIntent(menuItems, {
				// required parameters
				onEnter: function (targetItem) {
					targetItem.classList.add('menu-item-visible');
				},
				onExit: function (targetItem) {
					targetItem.classList.remove('menu-item-visible');
				},
				// default options
				exitDelay: 400,
				interval: 100,
				sensitivity: 7,
			});
		}
	}
});
